import { forwardRef } from 'react';
import { PublicAgent } from '@magic/schemas/agents';
import styled from 'styled-components';

import { Messages } from './components/messages';
import { Prompt } from './components/prompt';
import { Reset } from './components/reset';
import { ChatProvider, UseChatHelpers } from './context/chat';
import { Events } from './events';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export interface ChatProps {
  preview?: boolean;
  agent: PublicAgent;
}

export const Chat = forwardRef<UseChatHelpers, ChatProps>(
  ({ agent, preview }, ref) => {
    return (
      <ChatProvider
        ref={ref}
        api={import.meta.env.VITE_CHAT_API_URL}
        agent={agent}
        preview={preview}
      >
        <Container>
          <Messages />
          <Reset />
          <Prompt />
        </Container>

        <Events />
      </ChatProvider>
    );
  }
);

export type { UseChatHelpers };
